import { Button, Divider, Slider, Tooltip, Modal, Spin, message } from 'antd';
import SvgIcon from '&/components/SvgIcon';
import { hddDownload, hddRenderSameAngle } from '&/utils/common';
import UpgradeModal from '@/components/PhotoAlbumItem/UpgradeModal';
import ShareModal from '@/components/PhotoAlbumItem/ShareModal';
import {
    LeftOutlined,
    ZoomInOutlined,
    ZoomOutOutlined,
    RightOutlined,
    QuestionCircleOutlined,
} from '@ant-design/icons';
import { getAlbumList, deleteAlbum } from '@/api/hdd/album';
import Empty from '@/components/PhotoAlbumItem/Empty';
import usePreventDefault from '@/utils/customHooks/usePreventDefault';
import dayjs from 'dayjs';

import './PhotoDetail.scss';
import { useEffect } from 'react';

export default function PhotoDetail(props) {
    const schemeId =
        new URLSearchParams(window.location.search).get('schemeId') || 881;

    const renderId = new URLSearchParams(window.location.search).get('id');

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [shareModalOpen, setShareModalOpen] = useState(false);

    usePreventDefault();

    const renderAtAngle = () => {
        console.log('渲染同角度', active);
        let params = { camera: active?.camera, type: 0 };
        hddRenderSameAngle(params);
    };

    const upgradeHandle = () => {
        if (active.resolution === '4k') {
            return message.warning('该图片已是最高分辨率了');
        }
        setIsModalOpen(true);
    };

    const deleteFn = () => {
        console.log('delete');
        Modal.confirm({
            title: null,
            icon: null,
            content: `确认删除吗`,
            okText: '确认',
            cancelText: '取消',
            onOk: close => {
                deleteAlbum({ renderIds: [active.id] }).then(() => {
                    close();
                    setSliderList(prev => {
                        let index = prev.findIndex(v => v.id === active.id);
                        prev.splice(index, 1);
                        return [...prev];
                    });
                    setActive(sliderList[0]);
                });
            },
            onCancel: close => {
                close();
            },
        });
    };

    const [sliderList, setSliderList] = useState([]);

    const [active, setActive] = useState({});

    const [scale, setScale] = useState(1);

    const [originScale, setOriginScale] = useState(1);

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);

        getAlbumList({ hDocId: schemeId, status: 2, renderType: 0 })
            .then(res => {
                let list = res.data.list;
                setSliderList(list);
                setActive(list.find(v => v.id === renderId));
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    const handleNavClick = imgProps => {
        oDiv.current.style.transform = 'scale(1)';

        let wrapWidth = oDiv.current.offsetWidth;
        let wrapHeight = oDiv.current.offsetHeight;

        let img_url = imgProps.img;

        // 创建对象
        let img = new Image();

        // 改变图片的src
        img.src = img_url;

        // 加载完成执行
        img.onload = function () {
            // 打印
            if (img.width <= wrapWidth && img.height <= wrapHeight) {
                setScale(1);
                setOriginScale(1);
            } else {
                let _scale = Math.max(
                    wrapWidth / img.width,
                    wrapHeight / img.height
                );
                console.log('scale', _scale);
                // setOriginScale(parseFloat(_scale.toFixed(2)))
                // setScale(parseFloat(_scale.toFixed(2)))
                setOriginScale(1);

                setScale(1);
            }
        };

        setActive(imgProps);
    };

    const oDiv = useRef();

    const x = useRef();

    const y = useRef();

    const getTransform = DOM => {
        let arr = getComputedStyle(DOM, null).transform.split(',');
        return {
            transX: isNaN(+arr[arr.length - 2]) ? 0 : +arr[arr.length - 2], // 获取translateX
            transY: isNaN(+arr[arr.length - 1].split(')')[0])
                ? 0
                : +arr[arr.length - 1].split(')')[0], // 获取translateX
            multiple: +arr[3], // 获取图片缩放比例
        };
    };

    const mouseDown = e => {
        if (!oDiv.current) return;
        let transf = getTransform(oDiv.current);
        x.current = e.clientX - transf.transX; // 图片初始位置
        y.current = e.clientY - transf.transY; // 图片初始位置
        document.addEventListener('mousemove', mouseMove);
        document.addEventListener('mouseup', mouseUp);
    };

    const mouseMove = e => {
        if (!oDiv.current) return;
        let multiple = getTransform(oDiv.current).multiple;
        let moveX = e.clientX - x.current; // x向移动距离
        let moveY = e.clientY - y.current; // y向移动距离
        oDiv.current.style.transform = `matrix(${multiple}, 0, 0, ${multiple}, ${moveX}, ${moveY})`;
    };

    const mouseUp = () => {
        document.removeEventListener('mousemove', mouseMove);
        document.removeEventListener('mouseup', mouseUp);
    };

    const zoom = e => {
        let transf = getTransform(oDiv.current);
        // return
        if (e.deltaY < 0) {
            transf.multiple += 0.05; // 放大DELTA倍
        } else {
            transf.multiple -= 0.05; // 缩小DELTA倍
        }

        if (transf.multiple < 0.1 || transf.multiple > 4) return;

        setScale(parseFloat(transf.multiple.toFixed(2)));
    };

    const preventSelect = e => {
        e.preventDefault();
    };

    useEffect(() => {
        // 禁止选中文字/图片
        document.addEventListener('selectstart', preventSelect);
        // 鼠标按下事件
        console.log('oDiv', oDiv.current);
        if (!oDiv.current) return;
        oDiv.current.addEventListener('mousedown', mouseDown);
        // 图片缩放
        oDiv.current.addEventListener('wheel', zoom);

        return () => {
            document.removeEventListener('selectstart', preventSelect);
            if (oDiv.current) {
                oDiv.current.removeEventListener('mousedown', mouseDown);
                oDiv.current.removeEventListener('wheel', zoom);
            }
        };
    }, []);

    const onSliderChange = val => {
        let _val = parseFloat(val.toFixed(2));

        setScale(_val);
    };

    const formatter = value => `${(value * 100).toFixed(0)}%`;

    const isReset = useRef(false);

    const resetScale = () => {
        setScale(originScale);
        isReset.current = true;
        oDiv.current.style.transform = `scale(${1})`;
    };

    const onPlus = () => {
        if (scale > 4) return;

        setScale(prev => prev + 0.05);
    };

    useEffect(() => {
        if (!oDiv.current) return;
        let transf = getTransform(oDiv.current);
        if (isReset.current) {
            isReset.current = false;
        } else {
            oDiv.current.style.transform = `matrix(${scale}, 0, 0, ${scale}, ${transf.transX}, ${transf.transY})`;
        }
    }, [scale]);

    const onSubtract = () => {
        if (scale < 0.1) return;

        setScale(prev => prev - 0.05);
    };

    const prev = () => {
        setActive(sliderList[+activeIndex - 1]);
    };

    const next = () => {
        setActive(sliderList[+activeIndex + 1]);
    };

    const onGoBack = () => {
        props.history.goBack();
    };

    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        let index = sliderList.findIndex(v => v.id === active.id);
        console.log('index', index);
        setActiveIndex(index);
    }, [active]);

    const handleCreate = () => {
        console.log('chuangjian');
        try {
            window.external.DispatchFun('Atlas', 'CreateNormalImage', '');
        } catch (e) {}
    };

    return (
        <Spin spinning={loading}>
            <div className="photo-album-preview">
                <div className="header">
                    <div onClick={onGoBack} className="back-area">
                        <LeftOutlined /> 返回图册
                    </div>
                    <div className="title">{active?.title}</div>
                </div>
                <div className="content">
                    <div className="left-preview">
                        {!!sliderList.length && (
                            <>
                                <div className=" info-tip">
                                    普通图{active.resolution}{' '}
                                    <Divider type="vertical" />{' '}
                                    {active.pixelAspect}
                                    <Divider type="vertical" />{' '}
                                    {active.roomType}{' '}
                                    <Divider type="vertical" />{' '}
                                    {dayjs
                                        .unix(active.updateDate)
                                        .format('YYYY-MM-DD HH:mm:ss')}
                                </div>
                                <div className="slider">
                                    <ZoomOutOutlined onClick={onSubtract} />
                                    <Slider
                                        tipFormatter={formatter}
                                        min={0.1}
                                        step={0.05}
                                        max={4}
                                        value={scale}
                                        onChange={onSliderChange}
                                    />
                                    <ZoomInOutlined onClick={onPlus} />
                                </div>
                                <div className="scale" onClick={resetScale}>
                                    {(originScale * 100).toFixed(0)}%
                                </div>
                                <Button
                                    className="left-arrow"
                                    onClick={prev}
                                    disabled={+activeIndex === 0}>
                                    <LeftOutlined />
                                </Button>
                                <Button
                                    className="right-arrow"
                                    onClick={next}
                                    disabled={
                                        +activeIndex === sliderList.length - 1
                                    }>
                                    <RightOutlined />
                                </Button>
                                {/* <img
                                    ref={oDiv}
                                    style={{ transform: `scale(1)` }}
                                    draggable="false"
                                    src={active.renderUrl}></img> */}
                            </>
                        )}
                        <img
                            ref={oDiv}
                            style={{
                                transform: `scale(1)`,
                                display: !sliderList.length ? 'none' : 'block',
                            }}
                            draggable="false"
                            src={active?.renderUrl}></img>
                        {!sliderList.length && (
                            <Empty
                                tip="暂无普通图，请先渲染"
                                btnWord="创建普通图"
                                handleCreate={handleCreate}
                            />
                        )}
                    </div>
                    <div className="right-nav">
                        {sliderList.map(v => (
                            <div
                                className={`nav-wrap ${
                                    v.id === active.id ? 'active' : ''
                                } `}
                                key={v.id}
                                onClick={() => handleNavClick(v)}>
                                <img src={v.coverImageUrl}></img>
                                <div className="img-name">{v.title}</div>
                            </div>
                        ))}
                    </div>
                </div>
                <div
                    className="footer"
                    style={{
                        visibility: sliderList.length ? 'visible' : 'hidden',
                    }}>
                    <Button
                        type="text"
                        className="item"
                        key={0}
                        onClick={renderAtAngle}>
                        <SvgIcon iconName="Icon-Camera" />
                        <span className="word">渲染同角度</span>
                    </Button>
                    <Button
                        type="text"
                        key={1}
                        onClick={() =>
                            hddDownload([
                                {
                                    picturepath: active.renderUrl,
                                    picturename: active.title,
                                },
                            ])
                        }>
                        <SvgIcon iconName="Icon-Download1" />
                        <span className="word">下载</span>
                    </Button>
                    <Button type="text" key={2} onClick={upgradeHandle}>
                        <SvgIcon iconName="Icon-Upgrade" />
                        <span className="word">升级分辨率 </span>
                        <Tooltip
                            placement="top"
                            title={'升级后，原图将被替换不可恢复'}>
                            <QuestionCircleOutlined />
                        </Tooltip>
                    </Button>
                    <Button type="text" key={3} onClick={deleteFn}>
                        <SvgIcon iconName="Icon-Trash" />
                        <span className="word">删除</span>
                    </Button>
                </div>

                <UpgradeModal
                    isModalOpen={isModalOpen}
                    itemType={'album'}
                    // id={active?.id}
                    {...active}
                    getCurList={onGoBack}
                    setIsModalOpen={setIsModalOpen}
                />

                <ShareModal
                    isModalOpen={shareModalOpen}
                    setIsModalOpen={setShareModalOpen}
                />
            </div>
        </Spin>
    );
}
